(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxCreateNetwork(
    NetworkListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/createNetwork/createNetwork.template.html',
      link: function(scope) {

        scope.newNetwork = {
          name: ''
        };

        scope.addNewNetwork = function () {
          NetworkListService.addNewNetwork(scope.newNetwork.name).then(function(response) {
            var network = [{ info: response.data }];
            scope.context.addNetworksToSite(network).then(function(response) {
            }).catch(function(error){});
          }).catch(function(error){});
          scope.callback();
        }

      }
    };
  }

  pxCreateNetwork.$inject = ['NetworkListService'];

  angular
    .module('printix-admin')
    .directive('pxCreateNetwork', pxCreateNetwork);

})();
